import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const CustomAppDevelopment = () => {
     
  useEffect(() => {
    
    const win = window;

    function isElementVisible($el) {
      const viewTop = win.scrollY;
      const viewBottom = viewTop + window.innerHeight;
      const elTop = $el.offset().top;
      const elBottom = elTop + $el.height();
      return elBottom <= viewBottom && elTop >= viewTop;
    }
    $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
    function addAnimation($el, delay) {
        
      setTimeout(() => {
        $el.addClass("come-in");
        $el.attr("class", "webflow_circle come-in");
      }, delay);
    }

    const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
    const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
    const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
    const allMods4 = Array.from(document.querySelectorAll(".js_circle"));

    win.addEventListener("scroll", () => {
      allMods1.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods2.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods3.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods4.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });
    });

    const handleScroll = () => {
      const offset = window.pageYOffset;
      const wheight = window.innerHeight;
      const html = document.documentElement;
      const docheight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      let progress = (offset / (docheight - wheight)) * 3000;

      // Give the line a CSS gradient based on scroll position
      progress = 3000 - progress * 1.6;

      // Update the SVG element with the new stroke-dashoffset
      const fillingPath = document.getElementById("filling_path");
      if (fillingPath) {
        fillingPath.setAttribute("stroke-dashoffset", progress);
      }
    };

    // Add scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
        
      window.removeEventListener("scroll", handleScroll); 
    };
  }, []);
  const [ref, inView] = useInView({
    triggerOnce: true, // Ensures the animation occurs only once
    threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
  });

  const leftAnimation = {
    hidden: { opacity: 0, scale: 0, x: -200 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
    },
  };

  const image1Animation = {
    hidden: { opacity: 0, scale: 0, x: -200 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
    },
  };

  const image2Animation = {
    hidden: { opacity: 0, scale: 0, x: -200 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
    },
  };

  const image3Animation = {
    hidden: { opacity: 0, scale: 0, x: -200 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
    },
  };
   
  return (
    <>
      <div
        className="inner_banner service-banner"
        style={{ backgroundImage: "url(/assets/images/site/mobaile-dev.png)" }}
      >
        <div className="wrapper">
          <div className="banner_detail_1">
            <div className="details-ser">
              <h1 id="heading_line">Custom Mobile App Development</h1>
              <h2 id="sub_heading1">
                We craft tailor-made mobile applications designed to meet your
                business needs and offer unique user experiences. Whether you
                need an app for iOS, Android, or both, we’ve got you covered
                with cross-platform solutions.
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="why_coustom_app">
        <div className="wrapper">
          <h3>
            Why Choose <span>Custom Mobile App Development?</span>
          </h3>
          <p>
            In today’s fast-paced digital landscape, businesses must stand out
            with solutions that cater specifically to their target audience.
            Custom mobile apps provide a competitive edge by offering tailored
            functionality, optimized performance, and an enhanced user
            experience. Unlike off-the-shelf solutions, custom apps align
            perfectly with your business goals and adapt seamlessly to your
            workflows.
          </p>
          <h4>Our Expertise</h4>
          <p>
            At CodeFlix, we specialize in developing high-quality mobile
            applications that are both innovative and reliable.{" "}
          </p>
          <ul>
            <li>
              <b>Our team is experienced in: </b>
            </li>
            <ul>
              <li>
                <b>iOS App Development:</b> Leveraging Swift and Objective-C to
                create intuitive and high-performing apps for Apple devices.
              </li>
              <li>
                <b>Android App Development:</b> Harnessing Kotlin and Java to
                deliver robust applications for the Android ecosystem.
              </li>
              <li>
                <b>Cross-Platform Solutions:</b> Building apps with frameworks
                like Flutter and React Native to ensure a consistent experience
                across devices while reducing development time and costs.
              </li>
            </ul>
          </ul>
          <h4>Key Features of Our Custom Mobile Apps</h4>
          <ul>
            <li>
              <b>User-Centric Design:</b> Apps designed with your end-users in
              mind, ensuring an engaging and intuitive interface.
            </li>

            <li>
              <b>Scalable Architecture:</b> Solutions built to grow with your
              business, handling increased user demands effortlessly.
            </li>
            <li>
              <b>Secure Systems:</b> Implementation of advanced security
              protocols to protect user data and ensure compliance with industry
              standards.
            </li>
            <li>
              <b>Seamless Integration:</b> Compatibility with existing systems
              and third-party services for a unified digital experience.
            </li>
            <li>
              <b>Performance Optimization:</b> Apps optimized for speed,
              reliability, and resource efficiency.
            </li>
          </ul>
          <h4>The Development Process</h4>
          <p>
            Our development process is designed to ensure transparency,
            efficiency, and quality: Discovery Phase: Understanding your
            business needs, objectives, and target audience. Planning and
            Design: Creating a roadmap and crafting wireframes or prototypes for
            the app. Development: Writing clean, maintainable code while
            adhering to industry best practices. Testing: Rigorous testing to
            identify and fix bugs, ensuring a flawless user experience.
            Deployment and Maintenance: Launching the app on the desired
            platform(s) and providing ongoing support and updates.
          </p>
        </div>
      </div>
      <div className="why_us">
        <div className="wrapper">
          <h4>Benefits of Working with CodeFlix</h4>
          <div className="col_row">
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us5.svg" alt="" />
              </div>
              <hr />
              <h3>End-to-End Solutions</h3>
              <p>
                From ideation to deployment, we handle every aspect of the
                development process.
              </p>
            </div>
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us6.svg" alt="" />
              </div>
              <hr />
              <h3>Agile Methodology</h3>
              <p>
                Ensuring flexibility and faster delivery without compromising on
                quality.
              </p>
            </div>
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us7.svg" alt="" />
              </div>
              <hr />
              <h3>Experienced Team</h3>
              <p>
                A skilled team of developers, designers, and project managers
                dedicated to your success.
              </p>
            </div>
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us8.svg" alt="" />
              </div>
              <hr />
              <h3>Client-Centric Approach</h3>
              <p>
                Regular communication and collaboration to align the project
                with your vision.
              </p>
            </div>
          </div>
       <br />
        </div>
              </div>
            <div className="let_build">
                <div className="wrapper">
                <h4>Let’s Build <span> Your App Together </span></h4>
              
              <p>
                Whether you’re a startup looking to disrupt the market or an
                established enterprise aiming to enhance operational efficiency,
                CodeFlix is here to bring your vision to life. Let’s create a
                custom mobile app that drives results and delights your users.{" "}
                <br />
                Contact Us today to get started on your mobile app development
                journey.
              </p>
                </div>
            </div>
    </>
  );
};

export default CustomAppDevelopment;
